import config from '@/config';
import { useStore } from '@/store/useStore';
import { isLobbySameOriginDev } from '@/utilities/helpers/is-lobby-same-origin-dev';

export const getGlsBaseUrl = (region?: string): string => {
  if (isLobbySameOriginDev()) {
    return '';
  }

  const resolvedRegion =
    (region ?? useStore.getState().runtime.region)?.toUpperCase() ?? '';

  const glsConfig = config.GLS;
  if (glsConfig?.GLSBaseUrl?.[resolvedRegion]) {
    return glsConfig.GLSBaseUrl[resolvedRegion];
  }

  const endpoint = config.glsEndpoint;
  if (!endpoint) {
    throw new Error('[GLS] Missing GLS base URL configuration');
  }

  return endpoint.replace(
    '{state}',
    resolvedRegion.toLowerCase() || config.defaultRegion?.toLowerCase() || '',
  );
};
